import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SafeAnchor } from 'react-bootstrap';
import classNames from 'classnames';
export const NavbarBrand = props => {
    return (_jsx(_Fragment, { children: props.onClick ? (_jsx(SafeAnchor, Object.assign({ onClick: props.onClick, className: classNames(['navbar-brand', props.className]) }, { children: props.children }))) : (_jsx("span", Object.assign({ className: "navbar-brand" }, { children: props.children }))) }));
};
